
import { FC, useState, useEffect } from 'react';
import { Row, Col } from 'antd';
import { iconPreheaders, labelsPreHeaders } from '../../mocks/PreHeaderMock';
import { Link } from 'react-router-dom';
import { obtenerIcono } from './../util/AppIcons';
import useWindowDimensions from './../util/windows-dimension-hooks';
import { LayoutSize } from '../util/LayoutSize';

export const PreHeader: FC<{}> = (props) => {

    const [_style, setStyle] = useState({
        display: "block",
        transition: "",
        opacity: ""
    })

    const setPreheaderStyle = (display: string, transition: string = "", opacity: string = "") => {
        setStyle(prevState => {
            return { ...prevState, display: display, transition: transition, opacity: opacity };
        });
    }
    useEffect(() => {
        window.addEventListener('scroll', (e: any) => {
            let scrollYValue = window.pageYOffset
            if (scrollYValue === 0) {
                setPreheaderStyle("block")

            }
            if (scrollYValue > 0) {
                setPreheaderStyle("none", "opacity 1s ease-out", "0")

            }

        })
    }, [])

    return (
        <>
            {
                useWindowDimensions().width >= LayoutSize.l ?

                    <div id="pre-header-div" style={{ ..._style, backgroundColor: "black", height: "34px" }}>
                        <div style={{ paddingLeft: "40px", paddingTop: "5px" }}>
                            <Row justify='space-between'>
                                <Col >

                                    {
                                        labelsPreHeaders.map((_, index) =>
                                            <label className='label-pre-header' style={{ color: "white", marginRight: "20px" }}>
                                                <Link style={{ color: "white" }} to={_.link}>{_.text}</Link>
                                            </label>
                                        )
                                    }
                                </Col>
   

                                <Col >
                                    {
                                        iconPreheaders.map((_, index) =>
                                            <label className='label-pre-header' style={{ color: "white", marginRight: "20px" }}>
                                                <a rel="noreferrer" target="_blank" style={{ color: "white" }} href={_.link}>{obtenerIcono(_.icon)}</a>
                                            </label>
                                        )
                                    }

                                </Col>
                            </Row>


                          


                        </div>
                    </div>


                    :
                    <></>

            }

        </>

    )
}